/**
 * LayoutPickerButton - Dropdown to change admin layout (sidebar/compact/topnav).
 */
import React, { useState } from "react";
import { LayoutGrid, Rows3 } from "lucide-react";
import { LAYOUT_OPTIONS, SPACING_DENSITY } from "./navConfig";

export function LayoutPickerButton({ layout, onChange, showLayoutPicker, setShowLayoutPicker }) {
  return (
    <div className="relative">
      <button onClick={() => setShowLayoutPicker(!showLayoutPicker)}
        className="text-slate-400 hover:text-white p-1.5 rounded-lg hover:bg-slate-700/50 transition-colors"
        data-testid="layout-picker-btn" title="Změnit layout">
        <LayoutGrid className="w-4 h-4" />
      </button>
      {showLayoutPicker && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setShowLayoutPicker(false)} />
          <div className="absolute right-0 top-full mt-2 bg-white border border-slate-200 rounded-xl shadow-xl z-50 w-56 p-2" data-testid="layout-picker-dropdown">
            <p className="text-[10px] font-bold text-slate-400 uppercase tracking-wider px-2 py-1">Layout</p>
            {LAYOUT_OPTIONS.map(opt => (
              <button key={opt.key}
                onClick={() => { onChange(opt.key); setShowLayoutPicker(false); }}
                className={`w-full flex items-center gap-2.5 px-3 py-2 rounded-lg text-sm transition-colors ${
                  layout === opt.key ? "bg-emerald-50 text-emerald-700 font-semibold" : "text-slate-600 hover:bg-slate-50"
                }`}
                data-testid={`layout-option-${opt.key}`}>
                <opt.icon className="w-4 h-4 flex-shrink-0" />
                <div className="text-left">
                  <div className="text-sm font-medium">{opt.label}</div>
                  <div className="text-[10px] text-slate-400">{opt.desc}</div>
                </div>
                {layout === opt.key && <div className="ml-auto w-2 h-2 rounded-full bg-emerald-500" />}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}

export function SpacingDensityPicker({ density, onChange, dark }) {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <button onClick={() => setShow(!show)}
        className={`p-1.5 rounded-lg transition-colors ${dark ? "text-slate-400 hover:text-white hover:bg-slate-700/50" : "text-slate-400 hover:text-slate-700 hover:bg-slate-100"}`}
        data-testid="spacing-density-btn" title="Hustota zobrazeni">
        <Rows3 className="w-4 h-4" />
      </button>
      {show && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setShow(false)} />
          <div className="absolute right-0 top-full mt-2 bg-white border border-slate-200 rounded-xl shadow-xl z-50 w-44 p-2" data-testid="spacing-density-dropdown">
            <p className="text-[10px] font-bold text-slate-400 uppercase tracking-wider px-2 py-1">Hustota</p>
            {SPACING_DENSITY.map(opt => (
              <button key={opt.key}
                onClick={() => { onChange(opt.key); setShow(false); }}
                className={`w-full flex items-center gap-2 px-3 py-2 rounded-lg text-sm transition-colors ${
                  density === opt.key ? "bg-emerald-50 text-emerald-700 font-semibold" : "text-slate-600 hover:bg-slate-50"
                }`}
                data-testid={`spacing-density-${opt.key}`}>
                <span className="text-xs">{opt.label}</span>
                {density === opt.key && <div className="ml-auto w-2 h-2 rounded-full bg-emerald-500" />}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
